import { useMemo } from "react";
import { Link } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import Overview from "./Overview";
import { useDashboardV5 } from "./v5/useDashboardV5";
import { Hero, Kpis, BottomCards } from "./v5/V5Summary";
import { JobsPanel, Attention, MapPanel, Upcoming } from "./v5/V5Panels";
import "./v5/dashboardV5.css";

const OFFICE = ["super_admin", "admin", "office"];

// Office Overview (Dashboard V5). Other roles keep the existing Overview;
// every figure comes from existing org-scoped endpoints.
export default function OverviewV5() {
  const { user } = useAuth();
  if (!OFFICE.includes(user?.role)) return <Overview />;
  return <Dashboard user={user} />;
}

function Dashboard({ user }) {
  const { loading, data, failed, reload } = useDashboardV5();
  const usersById = useMemo(() => Object.fromEntries((data.users || []).map((u) => [u.id, u])), [data.users]);
  return (
    <div className="v5" data-testid="dashboard-v5">
      <Hero user={user} />
      <div className="v5-content">
        {!loading && failed.length > 0 && (
          <div className="v5-error" role="alert" data-testid="v5-error">Some dashboard data couldn't load ({failed.join(", ")}). <button onClick={reload}>Retry</button></div>
        )}
        <Kpis d={data} loading={loading} />
        <div className="v5-grid">
          <JobsPanel jobs={data.jobs} usersById={usersById} loading={loading} />
          <div>
            <div className="v5-topright">
              <Attention stats={data.stats} panel={data.panel} loading={loading} />
              <MapPanel jobs={data.jobs} loading={loading} />
            </div>
            <Upcoming panel={data.panel} assignments={data.assignments} loading={loading} />
          </div>
        </div>
        <BottomCards d={data} loading={loading} />
        <p className="v5-note">Live figures from your company's Fieldlink data. <Link className="v5-textBtn" to="/app/overview-classic" data-testid="v5-classic-link">Open the classic overview</Link></p>
      </div>
    </div>
  );
}
